import Chat from './chat';

export default Chat;



// WEBPACK FOOTER //
// ./src/components/widgets/chat/index.js